function urlBase64ToUint8Array(base64) {
  const pad = '='.repeat((4 - base64.length % 4) % 4);
  const b64 = (base64 + pad).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(b64);
  return new Uint8Array([...raw].map(c => c.charCodeAt(0)));
}

async function getVapidKey() {
  const res = await fetch('/api/push/vapid-public-key');
  const { key } = await res.json();
  return key || null;
}

async function subscribeAndSend(reg, key) {
  const token = localStorage.getItem('kspro_token');
  const existing = await reg.pushManager.getSubscription();
  const sub = existing || await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(key),
  });
  await fetch('/api/push/subscribe', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: JSON.stringify({ subscription: sub }),
  });
}

// Called on app load — only registers if permission already granted
export async function registerPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
  if (Notification.permission !== 'granted') return;
  try {
    const reg = await navigator.serviceWorker.register('/sw.js');
    const key = await getVapidKey();
    if (!key) return;
    await subscribeAndSend(reg, key);
  } catch (err) {
    console.warn('Push registration failed:', err);
  }
}

// Called on user gesture (Settings page button) — requests permission then subscribes
export async function enablePush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    throw new Error('Push notifications are not supported on this browser.');
  }
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') {
    throw new Error('Notification permission was denied.');
  }
  const reg = await navigator.serviceWorker.register('/sw.js');
  const key = await getVapidKey();
  if (!key) throw new Error('Push is not configured on the server.');
  await subscribeAndSend(reg, key);
}
